
const CertificatesData = [
    {
        title:"Java - LinkedIn",
    },
    {
        title:"Python - LinkedIn",
    },
    {
        title:"Web Developer",
    },
    {
        title:"JavaScript Zero - Hero",
    },
    {
        title:"ReactJS Bootcamp - Let's Upgrade",
    },
]
export default CertificatesData;